import React, { useState } from "react";
import ReactDOM from 'react-dom';
import "./SelectPlayerModal.scss";
import { useMutation, useSubscription } from "@apollo/client";
import { ADD_PLAYER_MUTATION } from "../api/queries";

const SelectPlayerModal = ({players, isShowing, hide, onComplete}) => {
    const createPlayerCompleted = () => {
        hide();
    }   

    if (!isShowing) return null;

    const playerSelected = (player) => {
        onComplete(player);
        hide();
    }

    return ReactDOM.createPortal(
        <React.Fragment>
        <div className="modal-overlay"/>
        <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
          <div className="modal">
            <div className="modal-header">
              <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close" onClick={hide}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div>
                <h3>Select Player</h3>
                <div className="flex-column">
                {
                    players.map(player => {
                        return (
                            <button className="player-button" onClick={() => playerSelected(player)}>{player.name}</button>
                        )
                    })
                }
                </div>
            </div>
          </div>
        </div>
      </React.Fragment>, document.body
    )
};

export default SelectPlayerModal;